export default __webpack_public_path__ + "static/media/002-agreement.054931e6.png";